export const SCOUT_IOS_AGENT = 'ImmoScout/ios'
export const SCOUT_ANDROID_AGENT = 'ImmoScout/android'

export const getUserAgent = () => navigator?.userAgent || ''

export const isUserAgentAndroidWebView = () => getUserAgent().includes(SCOUT_ANDROID_AGENT)

export const isUserAgentAndroidWebViewBuildNumberAtLeast = (buildNumber: number) => {
  const match = getUserAgent().match(/ImmoScout\/android\S*\/(\d+)(?:\s|$)/i)
  const androidNativeAppBuildNumber = match ? Number(match[1]) : null

  return androidNativeAppBuildNumber !== null && androidNativeAppBuildNumber >= buildNumber
}

export const isUserAgentIOSWebView = () => getUserAgent().includes(SCOUT_IOS_AGENT)

export const isUserAgentMobileWebView = () => isUserAgentAndroidWebView() || isUserAgentIOSWebView()

export const isUrlParamMobileWebView = (urlParams: URLSearchParams = new URLSearchParams(window.location.search)) =>
  urlParams.get('isMobileView') === 'true'

export const isMobileWebView = (urlParams: URLSearchParams = new URLSearchParams(window.location.search)) =>
  isUserAgentMobileWebView() || isUrlParamMobileWebView(urlParams)

export default isMobileWebView
